import { Row } from '@components'
import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleTabWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 24px;
`

export const StyleTabRow = styled(Row)<any>`
  column-gap: 10px;
  width: 100%;
  background-color: ${(props: any) =>
    props.withBg ? props.theme.colors.primary50 : 'none'};
  padding: ${(props: any) => (props.withBg ? '8px' : 'none')};
  flex-wrap: wrap;
  row-gap: 10px;
  @media (max-width: 1024px) {
    display: ${({ withBg }) => (withBg ? 'none' : 'flex')};
  }
  ${(props: any) => props?.customStyle}
`

export const StyleTabComponent = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const CustomSelect = styled.select<any>`
  border: 1px solid
    ${(props: any) =>
      props?.hasError
        ? props?.theme?.colors?.red800
        : props.theme.colors.borderColor};
  height: 45px;
  outline: none;
  text-indent: 10px;
  background-color: ${(props: any) =>
    props.theme.colors[props?.disabled ? 'disabledBg' : 'white']};
  color: ${(props: any) =>
    props.theme.colors[props?.isSelected ? 'black500' : 'grey100']};
  border-radius: 6px;
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none;
  cursor: ${(props: any) => (props?.disabled ? 'not-allowed' : 'auto')};
`

export const StyleDropdown = styled.div`
  position: relative;
  width: 100%;
  display: none;
  @media (max-width: 1024px) {
    display: block;
  }

  ::before {
    content: '';
    position: absolute;
    top: 20%;
    right: 36px;
    height: 60%;
    width: 1px;
    background-color: #ccc;
  }
  ::after {
    content: '';
    position: absolute;
    top: 45%;
    right: 16px;
    width: 6px;
    height: 6px;
    background: none;
    border-right: solid 2px #ccc;
    border-bottom: solid 2px #ccc;
    transform: translateY(-50%) rotate(45deg);
  }
`
export const StyleTabTitle = styled.p<any>`
  font-size: 16px;

  color: ${(props: any) =>
    props?.theme.colors[props?.isActive ? 'primary' : 'black']};
`

export const styleRow = `
display: none;
@media (max-width: 1024px) {
    display: flex;
  }
width:33%
@media max-width(480px) {
width:100%
}
`
interface IStyleTabItem {
  isActive?: boolean
  activeBg?: keyof typeof theme.colors
  inActiveBg?: keyof typeof theme.colors
  activeTc?: keyof typeof theme.colors
  inActiveTc?: keyof typeof theme.colors
  noBorder?: boolean
}
export const StyleTabItem = styled.div<IStyleTabItem>`
  height: 35px;
  gap: 8px;
  border-radius: 8px;
  border-width: 1px;
  padding-top: 8px;
  padding-right: 12px;
  padding-bottom: 8px;
  padding-left: 12px;
  background: ${(props: any) =>
    props.theme.colors[
      props?.isActive
        ? props.activeBg || 'primary50'
        : props.inActiveBg || 'tabBg'
    ]};
  align-items: center;
  display: flex;
  justify-content: center;
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  border-color: ${(props: any) =>
    props.theme.colors[
      props?.noBorder
        ? 'transparent'
        : props?.isActive
          ? 'primary50'
          : 'grey200'
    ]};
  p {
    color: ${(props: any) =>
      props.theme.colors[
        props?.isActive
          ? props.activeTc || 'primary'
          : props.inActiveTc || 'text100'
      ]};
  }
`
